module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-01.a2cc92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-01.png
// module id = IzaF
// module chunks = 1